import React, { useEffect, useState, useRef } from 'react';
import {
  createCategoryAction,
  deleteCategoryAction,
  getCategoryAction,
  updateBulkCategoryAction,
  updateCategoryAction,
} from '../../../../module/action/Category';
import { useDispatch, useSelector } from 'react-redux';
import { getSingleBookAction } from '../../../../module/action/Book';
import Spinner from '../../../../Constants/Spinner';
import BackIcon from '../../../../Assets/Icons/BackIcon';
import PlusBoxIcon from '../../../../Assets/Icons/PlusBoxIcon';
import LinesIcon from '../../../../Assets/Icons/LinesIcon';
import EditIcon from '../../../../Assets/Icons/EditIcon';
import DeleteIcon from '../../../../Assets/Icons/DeleteIcon';
import TicIcon from '../../../../Assets/Icons/TicIcon';
import PlusIcon from '../../../../Assets/Icons/PlusIcon';
import PN from 'persian-number';
import { convertToPersianNumber, reorder } from '../../../../module/ConstantFunctions';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import CategoryRow from './components/CategoryRow';
import ConfirmModal from '../../../../Constants/ConfirmModal';

const CatTableSub = ({
  addCatInTree,
  categoryTree,
  a,
  categories,
  setCategories,
  bookID,
  setCategoryTree,
  subCategoryData,
  editState,
  setEditState,
  setIdSelect,
  categoryMap,
  parentIndex,
}) => {
  const dispatch = useDispatch();
  const [categoryMapState, setCategoryMapState] = useState([]);
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    setCategoryMapState(categoryMap);
  }, [categoryMap]);
  function onDragEnd(result, type, categoriesState) {
    // dropped outside the list
    if (categoriesState && result?.source?.index >= 0 && result?.destination?.index >= 0) {
      console.log(result.destination, result.source.index, result.destination.index, 'dragEnd');
      if (!result.destination) {
        return;
      }

      const items = reorder(categoriesState, result.source.index, result.destination.index);
      let updatedList = items.map((a, i) => {
        return {
          ...a,
          id: i,
        };
      });
      dispatch(updateBulkCategoryAction(updatedList, setLoader));
      setCategoryMapState(updatedList);
    }
  }

  return (
    <>
      {loader ? (
        <div className="absolute w-full h-full bottom-0 left-0 max-h-[240px] min-h-[240px] sm:w-[354px] w-[300px] sm:min-w-[354px] min-w-0  z-10  flex items-center justify-center">
          <div className="bg-[#2a91342e] p-[5px] w-[50px] aspect-square flex justify-center items-center shadow-md  rounded-[7px] relative">
            <Spinner color={'#2a9134'} />
          </div>
        </div>
      ) : null}
      <div className="relative categoriesDiv w-[338px] min-w-[338px] max-h-[240px] min-h-[240px] overflow-auto mr-4 ">
        <DragDropContext onDragEnd={result => onDragEnd(result, 'sub', categoryMapState)}>
          <Droppable droppableId="droppable">
            {provided => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                className="table border-separate border-spacing-y-[4px] border-spacing-x-[0px] w-full">
                {categoryMapState
                  .sort((a, b) => a.id - b.id)
                  .map((b, j) => (
                    <CategoryRow
                      addCatInTree={addCatInTree}
                      main={false}
                      categoryTree={categoryTree}
                      a={b}
                      bookID={bookID}
                      refId={a}
                      setCategoryTree={setCategoryTree}
                      subCategoryData={subCategoryData}
                      index={parentIndex + 1}
                      dndIndex={j + 1}
                      key={j}
                      editState={editState}
                      setEditState={setEditState}
                      setIdSelect={setIdSelect}
                    />
                  ))}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </>
  );
};

const CatTable = ({
  setCategories,
  categories,
  addCatInTree,
  categoryTree,
  data,
  bookID,
  setCategoryTree,
  subCategoryData,
  editState,
  setEditState,
  setIdSelect,
  categoryMap,
  type,
  main,
}) => {
  const dispatch = useDispatch();
  const [categoryMapState, setCategoryMapState] = useState([]);
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    setCategoryMapState(categoryMap);
  }, [categoryMap]);
  function onDragEnd(result, type, categoriesState) {
    // dropped outside the list
    if (categoriesState && result?.source?.index >= 0 && result?.destination?.index >= 0) {
      console.log(result.destination, result.source.index, result.destination.index, 'dragEnd');
      if (!result.destination) {
        return;
      }

      const items = reorder(categoriesState, result.source.index, result.destination.index);
      let updatedList = items.map((a, i) => {
        return {
          ...a,
          id: i,
        };
      });
      dispatch(updateBulkCategoryAction(updatedList, setLoader));

      setCategoryMapState(updatedList);
    }
  }
  return (
    <>
      {loader ? (
        <div className="absolute top-[20px] w-full h-full bottom-0 left-0 max-h-[240px] min-h-[240px] sm:w-[354px] w-[300px] sm:min-w-[354px] min-w-0  z-10  flex items-center justify-center">
          <div className="bg-[#2a91342e] p-[5px] w-[50px] aspect-square flex justify-center items-center shadow-md  rounded-[7px] relative">
            <Spinner color={'#2a9134'} />
          </div>
        </div>
      ) : null}
      <div className="relative categoriesDiv sm:w-[338px] w-[300px] sm:min-w-[338px] min-w-0 max-h-[240px] min-h-[240px] overflow-auto mr-4">
        <DragDropContext onDragEnd={result => onDragEnd(result, type, categoryMapState)}>
          <Droppable droppableId="droppable">
            {provided => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                className="table border-separate border-spacing-y-[4px] border-spacing-x-[0px] w-full">
                {categoryMapState
                  .sort((a, b) => a.id - b.id)
                  .map((a, i) => (
                    <CategoryRow
                      addCatInTree={addCatInTree}
                      main={main}
                      categoryTree={categoryTree}
                      a={a}
                      refId={data._id}
                      bookID={bookID}
                      setCategoryTree={setCategoryTree}
                      subCategoryData={subCategoryData}
                      index={i + 1}
                      key={i}
                      editState={editState}
                      setEditState={setEditState}
                      setIdSelect={setIdSelect}
                    />
                  ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </>
  );
};

const CategoriesSection = ({ categoryArr, setCategoryArr, index, data, bookID, subCategoryData }) => {
  const dispatch = useDispatch();
  const [categories, setCategories] = useState([]);
  const createCategoryLoader = useSelector(e => e.Category.createCategoryLoader);

  const [editState, setEditState] = useState('');
  const [updateLoader, setUpdateLoader] = useState(false);
  const [disabled, setDisable] = useState(false);
  const [disabledEdit, setDisableEdit] = useState(false);

  const [catObj, setCatObj] = useState({
    bookId: bookID,
    category_name: '',
    typeCategory: 'Main',
    refId: null,
    chapterName: '',
  });

  useEffect(() => {
    if (bookID) {
      setCatObj({
        bookId: bookID,
        category_name: '',
        typeCategory: 'Main',
        refId: null,
        chapterName: '',
      });
    }
  }, [bookID]);

  useEffect(() => {
    if (data) {
      setCatObj(data);
      setDisableEdit(data._id ? true : false);
    }
  }, [data]);

  useEffect(() => {
    if (subCategoryData.length) {
      let arr = [];
      subCategoryData.map((a, i) => {
        if (a.refId === data._id) {
          arr.push({ ...a, index: a.id });
        }
      });
      setCategories(arr);
    }
  }, [subCategoryData, data]);

  const addCat = () => {
    let arr = [...categories];
    setIdSelect(data._id);
    arr.push({
      bookId: bookID,
      category_name: '',
      typeCategory: 'Sub',
      refId: data._id,
      chapterName: null,
      id: categories.length + 1,
    });
    setCategories(arr);
  };

  const [categoryTree, setCategoryTree] = useState(false);

  const [anwan, setAnwan] = useState([]);
  const [type, setType] = useState(true);
  const [idSelect, setIdSelect] = useState();
  const [indexSelect, setIndexSelect] = useState(0);
  const addCatInTree = (data, main, index, addName) => {
    if (main) {
      setType(true);
      setIdSelect(data._id);
      let arrCat = [];
      console.log(subCategoryData);
      subCategoryData.map((a, i) => {
        if (a.refId === data._id) {
          arrCat.push({ ...a, index: a.id });
        }
      });

      let obj = {
        [data._id]: [...arrCat],
      };
      if (addName) {
        let arr = [];
        arr.push(data.category_name);
        setAnwan(arr);
      }
      setCategoryTree(obj);
    } else {
      setType(false);
      setIdSelect(data._id);

      let updatedObj = {};
      let keyToRemove = Object.keys(categoryTree)[index];
      setIndexSelect(index);
      for (let key in categoryTree) {
        if (keyToRemove === key) {
          break;
        }
        updatedObj = {
          ...updatedObj,
          [key]: categoryTree[key],
        };
      }

      let arrCat = [];
      subCategoryData.map((a, i) => {
        if (a.refId === data._id) {
          arrCat.push({ ...a, index: a.id });
        }
      });

      let obj = {
        ...updatedObj,
        [data._id]: [...arrCat],
      };
      if (addName) {
        anwan.splice(index);

        let arr = [...anwan];
        arr.push(data.category_name);
        setAnwan(arr);
      }
      setCategoryTree(obj);
    }
  };

  useEffect(() => {
    if (subCategoryData.length) {
      if (categoryTree) {
        let key = idSelect;
        let data = subCategoryData.filter(obj => obj._id === key)[0];
        if (key === data?._id) {
          addCatInTree(data, type, indexSelect, false);
        }
      }
    }
  }, [subCategoryData, type, idSelect, indexSelect]);

  const addCatInSubTree = data => {
    let arr = [...categoryTree[data]];
    arr.push({
      bookId: bookID,
      category_name: '',
      typeCategory: 'Sub',
      refId: data,
      chapterName: null,
      id: arr.length + 1,
    });
    setCategoryTree({
      ...categoryTree,
      [data]: arr,
    });
  };

  const ourRef = useRef(null);
  const [isMouseDown, setIsMouseDown] = useState(false);
  const mouseCoords = useRef({
    startX: 0,
    startY: 0,
    scrollLeft: 0,
    scrollTop: 0,
  });

  const handleDragStart = e => {
    if (!ourRef.current) return;
    const slider = ourRef.current.children[0];
    const startX = e.pageX - slider.offsetLeft;
    const startY = e.pageY - slider.offsetTop;
    const scrollLeft = slider.scrollLeft;
    const scrollTop = slider.scrollTop;
    mouseCoords.current = { startX, startY, scrollLeft, scrollTop };
    setIsMouseDown(true);
    document.body.style.cursor = 'grabbing';
  };
  const handleDragEnd = () => {
    setIsMouseDown(false);
    if (!ourRef.current) return;
    document.body.style.cursor = 'default';
  };
  const handleDrag = e => {
    if (!isMouseDown || !ourRef.current) return;
    e.preventDefault();
    const slider = ourRef.current.children[0];
    const x = e.pageX - slider.offsetLeft;
    const y = e.pageY - slider.offsetTop;
    const walkX = (x - mouseCoords.current.startX) * 1.5;
    const walkY = (y - mouseCoords.current.startY) * 1.5;
    slider.scrollLeft = mouseCoords.current.scrollLeft - walkX;
    slider.scrollTop = mouseCoords.current.scrollTop - walkY;
  };

  const saveCategory = () => {
    dispatch(createCategoryAction(catObj));
  };

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteLoader, setDeleteLoader] = useState(false);
  const onClickDelete = () => setDeleteModalOpen(true);
  const onDeleteCategory = () => dispatch(deleteCategoryAction(data._id, data.typeCategory, bookID, setDeleteLoader));
  const onCancelDeleteCategory = () => setDeleteModalOpen(false);

  const updateCat = (id, type) => {
    dispatch(updateCategoryAction(catObj, catObj._id, type, bookID, setUpdateLoader));
  };

  useEffect(() => {
    if (createCategoryLoader) {
      setDisable(true);
    } else if (catObj.category_name && catObj.chapterName) {
      setDisable(false);
    } else {
      setDisable(false);
    }
  }, [catObj, createCategoryLoader]);

  return (
    <div className="mt-16" key={index}>
      <div className="bg-[#eef2f0] p-6 pb-0">
        <div className="flex sm:justify-between flex-wrap">
          <label className="dastaNaam flex items-center justify-between bg-white  px-6 rounded-[10px] sm:w-[calc(100%-177px)] w-full sm:mb-[0px] mb-[8px]">
            <div className="flex items-center">
              <LinesIcon />

              <input
                value={catObj.category_name}
                disabled={disabledEdit}
                className="urduInput font-bold text-black placeholder:text-black text-[32px] outline-none ml-6 w-full"
                placeholder="نام دسته"
                onChange={ev => {
                  let obj = { ...catObj };
                  obj.category_name = ev.target.value;
                  setCatObj(obj);
                }}
              />
            </div>

            <p className="urduInput text-4xl text-black font-bold">
              {convertToPersianNumber(String(index + 1))} / {PN.convertEnToPe(categoryArr.length)}
            </p>
          </label>
          <div className="flex flex-wrap w-[169px]">
            {catObj._id ? (
              <>
                {disabledEdit ? (
                  <button
                    disabled={updateLoader}
                    className="relative bg-[#000] text-white flex mr-[8px]  items-center justify-center px-6 h-[48px] rounded-xl "
                    onClick={() => {
                      if (disabledEdit) {
                        setDisableEdit(!disabledEdit);
                      }
                    }}>
                    {updateLoader ? <Spinner /> : null}
                    <span
                      className={
                        updateLoader
                          ? `opacity-0 flex items-center justify-center cursor-not-allowed`
                          : 'flex items-center justify-center'
                      }>
                      <EditIcon width={26} height={24} fill={'#fff'} />
                      Edit
                    </span>
                  </button>
                ) : (
                  <button
                    disabled={disabled}
                    className="relative bg-[#2a9134] text-white flex mr-[8px]  items-center justify-center px-6 h-[48px] rounded-xl disabled:opacity-50 disabled:cursor-not-allowed "
                    onClick={() => {
                      updateCat(data._id, data.typeCategory);
                      setDisableEdit(!disabledEdit);
                    }}>
                    {createCategoryLoader ? <Spinner /> : null}
                    <span
                      className={
                        createCategoryLoader
                          ? `opacity-0 flex items-center justify-center`
                          : 'flex items-center justify-center'
                      }>
                      <TicIcon className="mr-1.5" stroke="#fff" />
                      Save
                    </span>
                  </button>
                )}

                <button
                  disabled={deleteLoader}
                  className="relative bg-[#ca3030] text-white h-[48px] w-[48px] rounded-xl flex items-center justify-center"
                  onClick={onClickDelete}>
                  {deleteLoader ? <Spinner /> : null}

                  <span
                    className={
                      deleteLoader ? `opacity-0 flex items-center justify-center` : 'flex items-center justify-center'
                    }>
                    <DeleteIcon pathProp={{ fill: '#fff' }} />
                  </span>
                </button>
              </>
            ) : (
              <>
                <button
                  disabled={disabled}
                  className="relative bg-[#2a9134] text-white flex mr-[8px]  items-center justify-center px-6 h-[48px] rounded-xl disabled:opacity-50 disabled:cursor-not-allowed "
                  onClick={() => {
                    saveCategory();
                  }}>
                  {createCategoryLoader ? <Spinner /> : null}
                  <span
                    className={
                      createCategoryLoader
                        ? `opacity-0 flex items-center justify-center`
                        : 'flex items-center justify-center'
                    }>
                    <TicIcon className="mr-1.5" stroke="#fff" />
                    Save
                  </span>
                </button>
              </>
            )}
          </div>
        </div>
        <div className="categories">
          <div className="mt-6">
            <div
              ref={ourRef}
              onMouseDown={handleDragStart}
              onMouseUp={handleDragEnd}
              onMouseMove={handleDrag}
              className="flex">
              <div className="flex overflow-auto pb-6">
                <div className="relative">
                  <p
                    className="font-semibold sticky top-0 bg-[#eef2f0]"
                    onClick={() => {
                      console.log(categories);
                    }}>
                    All Categories
                  </p>
                  <CatTable
                    setCategories={setCategories}
                    categories={categories}
                    addCatInTree={addCatInTree}
                    categoryTree={categoryTree}
                    data={data}
                    bookID={bookID}
                    setCategoryTree={setCategoryTree}
                    subCategoryData={subCategoryData}
                    editState={editState}
                    setEditState={setEditState}
                    setIdSelect={setIdSelect}
                    categoryMap={categories}
                    type={'main'}
                    main={true}
                  />
                  <button
                    disabled={
                      disabled || (categories.length && !categories[categories.length - 1]._id) || !disabledEdit
                    }
                    onClick={addCat}
                    className="bg-[#2a9134] text-white flex items-center justify-center px-6 h-[48px] rounded-xl  sm:w-[338px] w-[300px] sm:min-w-[338px] min-w-0 disabled:opacity-50 disabled:cursor-not-allowed">
                    <PlusIcon className="mr-2" />
                    New Category
                  </button>
                </div>
                {Object.keys(categoryTree).map((a, i) =>
                  categoryTree[a].length ? (
                    <div className="relative" key={i}>
                      <p className="font-semibold bg-[#eef2f0]">{anwan[i]}</p>
                      <button
                        disabled={!categoryTree[a][categoryTree[a].length - 1]._id || idSelect !== a}
                        onClick={() => addCatInSubTree(a)}
                        className="bg-[#2a9134] disabled:opacity-[0.4] mt-[8px] disabled:cursor-not-allowed text-white flex items-center justify-center px-6 h-[48px] rounded-xl  sm:w-[338px] w-[300px] sm:min-w-[338px] min-w-0">
                        <PlusIcon className="mr-2" />
                        Add New
                      </button>
                      <CatTableSub
                        addCatInTree={addCatInTree}
                        categoryTree={categoryTree}
                        a={a}
                        categories={categories}
                        setCategories={setCategories}
                        bookID={bookID}
                        setCategoryTree={setCategoryTree}
                        subCategoryData={subCategoryData}
                        editState={editState}
                        setEditState={setEditState}
                        setIdSelect={setIdSelect}
                        categoryMap={categoryTree[a]}
                        parentIndex={i}
                      />
                    </div>
                  ) : (
                    <div className="w-[338px] min-w-[338px] max-h-[240px] relative" key={i}>
                      <div className="absolute w-full top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] text-center flex flex-col justify-center items-center">
                        <p className="text-[#7b867c] mb-6">
                          Add sub-category to <br /> selected category.
                        </p>
                        <button
                          className="text-base flex justify-center items-center  bg-black  py-4 rounded-xl mb-2 px-6 text-white leading-[9px]"
                          onClick={() => {
                            addCatInSubTree(a);
                          }}>
                          <PlusIcon className="mr-2" />
                          New Category
                        </button>
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <ConfirmModal //
        loading={deleteLoader}
        open={deleteModalOpen}
        onCancel={onCancelDeleteCategory}
        content="Do you want to delete this Category?"
        cancelText="No"
        okText="Yes, Delete"
        onOk={onDeleteCategory}
      />
    </div>
  );
};

function Categories() {
  const dispatch = useDispatch();
  const [bookID, setBookID] = useState();
  const getSingleBook = useSelector(e => e.Book.getSingleBook);
  const CategoryData = useSelector(e => e.Category.CategoryData);
  const subCategoryData = useSelector(e => e.Category.subCategoryData);
  const [categoryArr, setCategoryArr] = useState([]);

  useEffect(() => {
    const url = new URL(window.location);
    const bookId = url.searchParams.get('id');
    setBookID(bookId);
    if (bookId) {
      setCategoryArr([
        {
          bookId: bookId,
          category_name: '',
          typeCategory: 'Main',
          refId: null,
          chapterName: '',
        },
      ]);

      dispatch(getSingleBookAction(bookId));
      dispatch(getCategoryAction(bookId, 'Main'));
      dispatch(getCategoryAction(bookId, 'Sub'));
    }
  }, []);

  useEffect(() => {
    if (CategoryData) {
      setCategoryArr(CategoryData);
    }
  }, [CategoryData]);

  return (
    <div className="Categories my-12 px-8 innerDashboard">
      <div className="header  justify-between flex">
        <div className="flex align-middle items-center">
          <div className="flex items-center">
            <button
              className="bg-[#eef2f0] flex items-center justify-center w-[48px] h-[48px] rounded-xl mr-4"
              onClick={() => window.history.back()}>
              <BackIcon />
            </button>
            <div>
              <p className="text-[#7b867c]">Table of content</p>
              <h2 className="text-[24px] font-extrabold leading-[22px]">{getSingleBook.bookName}</h2>
            </div>
          </div>
        </div>
        {categoryArr.length ? (
          <button
            className="text-base flex justify-center items-center bg-gray-100  py-[12px] rounded-xl mb-2 px-[25px] font-bold"
            onClick={() => {
              let arr = [...categoryArr];
              arr.push({
                bookId: bookID,
                category_name: '',
                typeCategory: 'Main',
                refId: null,
                chapterName: '',
              });
              setCategoryArr(arr);
            }}>
            <PlusBoxIcon svgProp={{ className: 'mr-2' }} pathProp={{ stroke: '#000' }} />
            New Parent Category
          </button>
        ) : null}
      </div>

      {categoryArr.length ? (
        categoryArr.map((a, i) => {
          return (
            <CategoriesSection
              categoryArr={categoryArr}
              setCategoryArr={setCategoryArr}
              index={i}
              data={a}
              bookID={bookID}
              subCategoryData={subCategoryData}
            />
          );
        })
      ) : (
        <div>
          <div className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] text-center">
            <p className="text-[#7b867c] mb-6">There are no categories</p>

            <button
              className="text-base flex justify-center items-center  bg-gray-100  py-4 rounded-xl mb-2 px-[53px] font-bold"
              onClick={() => {
                let arr = [...categoryArr];
                arr.push({
                  bookId: bookID,
                  category_name: '',
                  typeCategory: 'Main',
                  refId: null,
                  chapterName: '',
                });
                setCategoryArr(arr);
              }}>
              <PlusBoxIcon svgProp={{ className: 'mr-[6px]' }} pathProp={{ stroke: '#000' }} />
              New Parent Category
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Categories;
